import { z } from 'zod';

export const STORE_PAGE_TABS = ['settings', 'details'] as const;

export type StorePageTab = (typeof STORE_PAGE_TABS)[number];

/** `?tab=` on the store page; anything else falls back to the settings hub. */
export const storePageSearchSchema = z.object({
  tab: z.enum(STORE_PAGE_TABS).optional().catch(undefined),
});

export type StorePageSearch = z.infer<typeof storePageSearchSchema>;
